import { AutoSendNoteTarget } from "../../../utils/hooks/useEtaxAutoSendActions";
import NoteDialog from "./NoteDialog";
import { getNeedsAckReason } from "./autoSendMeta";

interface AutoSendNoteDialogProps {
  target: AutoSendNoteTarget | null;
  loading: boolean;
  onClose: () => void;
  onConfirm: (note: string | null) => void;
}

/** The note dialog behind a row's "ไม่ส่งอัตโนมัติ" and "รับทราบ" actions. */
export default function AutoSendNoteDialog({
  target,
  loading,
  onClose,
  onConfirm,
}: AutoSendNoteDialogProps) {
  const doc = target?.doc;
  const isHold = target?.action === "HOLD";

  const facts = doc
    ? [
        { label: "เลขที่บิล", value: doc.transaction_no },
        { label: "ลูกค้า", value: doc.customer_name || "-" },
        ...(isHold ? [] : [{ label: "สาเหตุ", value: getNeedsAckReason(doc) }]),
      ]
    : [];

  return (
    <NoteDialog
      open={Boolean(target)}
      title={isHold ? "ไม่ส่งอัตโนมัติ" : "รับทราบ"}
      facts={facts}
      description={
        isHold
          ? "บิลนี้จะไม่ถูกส่งในรอบส่งอัตโนมัติจนกว่าจะยกเลิก ยังส่งเองได้ตามปกติ"
          : "บันทึกว่ารับทราบปัญหาของเอกสารนี้แล้ว รายการจะหายจากกลุ่มรอรับทราบ"
      }
      confirmLabel={isHold ? "ยืนยันไม่ส่งอัตโนมัติ" : "ยืนยันรับทราบ"}
      confirmColor={isHold ? "primary" : "warning"}
      loading={loading}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
}
